import { Tooltip } from 'bootstrap';

/**
 * Bootstrap-tooltips är opt-in och måste initieras explicit.
 *
 * Ersätter tooltip-delen av FrontendSrc/patternlab/js/tooltip.js. Popover-delen
 * porteras INTE hit - site.ts initierar redan popovers med rätt html-inställning
 * för hjälptexterna i donationsformuläret, och en andra initiering här hade
 * skapat dubbla instanser på samma element.
 */
export function initTooltips(): void {
    document.querySelectorAll<HTMLElement>('[data-bs-toggle="tooltip"]').forEach(el => {
        Tooltip.getOrCreateInstance(el);
    });
}
